import { store } from "../redux/store";
import { CalcRequestPlace } from "../types/enums";
export function prepareTariffs(tariffs) {
    return tariffs.filter(function (item) {
        var _a = store.getState(), insurance = _a.insurance, requestPlace = _a.requestPlace, personalScore = _a.personalScore;
        if (item.allowOnline === 0) {
            return false;
        }
        //На 32 шаге приходит пустой массив и здесь уже проверяем наличие страховок, а на публичном только null
        if ((requestPlace.requestPlace === CalcRequestPlace.STEP32 || requestPlace.requestPlace === CalcRequestPlace.STEP232) && (insurance.insurance === null || insurance.insurance === false || insurance.insurance.length === 0) && item.insuranceNeed === 2) {
            return false;
        }
        if ((requestPlace.requestPlace === CalcRequestPlace.STEP32 && personalScore.personalScore === null) && item.creditRatingNeed === 2) {
            return false;
        }
        return true;
    });
}
